module.exports = __webpack_public_path__ + "img/root-bg.ddbec08d.svg";